<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions } from "vuex";

export default {
  name: "App",
  
  methods: {
    ...mapActions(['saveVisitData', 'checkUserAgentHistory', 'checkEmail']),
      async registerVisit(){
          
        try {
            const response = await axios.get(`${process.env.VUE_APP_LOCAL_API}ip/`);
            this.ip = response.data.success ? response.data.ip : 'none';
        } catch(err){
            console.log(err);
        }
        const params = {
            domain: process.env.VUE_APP_SITE_URL,
            variation: process.env.VUE_APP_VARIATION,
            ip: this.ip,
            agent: this.USER_AGENT,
            subid1: this.subid1,
            subid2: this.subid2,
            subid3: this.subid3,
            subid4: this.subid4,
            utm_source: this.utm_source,
            utm_campaign: this.utm_campaign,
            utm_medium: this.utm_medium,
            utm_content: this.utm_content,
            referrer: process.env.VUE_APP_SITE_URL,
            sc: this.sc,
            sk: this.sk,
            webmasterID: this.webmasterID,
            subaccount: this.subaccount
        };
        this.saveVisitData(params);
      },
  },
  data() {
      return {
          ip: '',
          utm_source: '',
          utm_campaign: '',
          utm_medium: '',
          utm_content: '',
          subid1: '',
          subid2: '',
          subid3: '',
          subid4: '',
          sc: '',
          sk: '',
          webmasterID: '',
          subaccount: '',
      }
  },
  computed: {
    USER_AGENT() {
        return navigator.userAgent;
    }
  },
  created(){
    const urlParams = new URLSearchParams(window.location.search);
    this.utm_source = urlParams.has('utm_source') ? urlParams.get('utm_source') : 'none';
    this.utm_campaign = urlParams.has('utm_campaign') ? urlParams.get('utm_campaign') : 'none';
    this.utm_medium = urlParams.has('utm_medium') ? urlParams.get('utm_medium') : 'none';
    this.utm_content = urlParams.has('utm_content') ? urlParams.get('utm_content') : 'none';
    let subid = urlParams.has('subid') ? urlParams.get('subid') : '';
    if(subid === '') {
        subid = urlParams.has('s1') ? urlParams.get('s1') : '';
    }
    if(subid === '') {
        subid = urlParams.has('s') ? urlParams.get('s') : '';
    }
    
    this.subid1 = subid;
    this.subid2 = urlParams.has('s2') ? urlParams.get('s2') : '';
    this.subid3 = urlParams.has('s3') ? urlParams.get('s3') : '';
    this.subid4 = urlParams.has('s4') ? urlParams.get('s4') : '';
    this.sc = urlParams.has('sc') ? urlParams.get('sc') : '';
    this.sk = urlParams.has('sk') ? urlParams.get('sk') : '';
    this.webmasterID = urlParams.has('aid') ? urlParams.get('aid') : '';
    this.subaccount = urlParams.has('subacc') ? urlParams.get('subacc') : '';
  },
  mounted(){
      this.registerVisit();
  }
}
</script>


<style>

</style>